import React from 'react';
import * as Styled from './style';
import ImgTopRight from '../../assets/images/ChatbotRingSavvy_Img2.png';
import ImgBottomLeft from '../../assets/images/ChatbotRingSavvy_Img1.png';

const benefits = [
  {
    title: 'Fully customizable intake',
    description: 'You decide what the chatbot will ask your web visitors.',
  },
  {
    title: 'Instant answers, 24/7',
    description:
      'The chatbot is trained to answer questions about your hours, services, and more.',
  },
  {
    title: 'Human-like responses',
    description:
      'Conversational AI technology makes every chat feel like a real interaction.',
  },
  {
    title: 'Integrated scheduling',
    description:
      'Every customer will get an opportunity to schedule an appointment with your business.',
  },
  {
    title: 'Review leads from anywhere',
    description:
      'With the Ring Savvy app, you’ll be able to follow up with web leads right away.',
  },
];

export default function IntakeSection() {
  return (
    <Styled.Section>
      <Styled.Container>
        <Styled.TopRow>
          <div style={{ paddingTop: '64px', paddingBottom: '64px' }}>
            <Styled.Title>
              Convert web leads into customers with AI
            </Styled.Title>
            <div
              style={{
                backgroundColor: '#00B453',
                width: '200px',
                height: '4px',
                borderRadius: '5px',
              }}
            ></div>
            <Styled.Description>
              Once a lead is on your website, our free AI chatbot will help
              ensure they become a customer with natural, intelligent, and
              human-like responses to their inquiries.
            </Styled.Description>
          </div>
          <Styled.ImageRight src={ImgTopRight} alt='Chatbot screenshot' />
        </Styled.TopRow>

        <Styled.BenefitSection>
          <Styled.CurveCircle />
          <Styled.ImageLeft src={ImgBottomLeft} alt='Chat UI' />

          <div>
            <Styled.List>
              <Styled.Subtitle>
                Here’s what you get with AI-powered intake
              </Styled.Subtitle>
              {benefits.map((item, i) => (
                <Styled.ListItem key={i}>
                  <strong>{item.title}</strong>
                  <p>{item.description}</p>
                </Styled.ListItem>
              ))}
            </Styled.List>
          </div>
        </Styled.BenefitSection>
      </Styled.Container>
    </Styled.Section>
  );
}
